<template>
  <div style="color:#6c757d !important;">
    <!-- ----------------------------------- -->
    <!-- navbar starts -->
    <vs-navbar
      v-model="indexActive"
      :color="colorx"
      text-color="rgba(255,255,255,.6)"
      active-text-color="rgba(255,255,255,1)"
      class="myNavbar"
    >
      <div slot="title">
        <vs-navbar-title>Graphs Presentations</vs-navbar-title>
      </div>
    </vs-navbar>
    <!-- navbar ends -->
    <!-- ----------------------------------- -->
    <!-- container starts -->
    <div class="container mt-5">
      <div class="row">
        <div class="col-sm-12 p-0 print-scr">
          <span class="btn btn-primary float-right btn-sm print-btn" @click="printReport">
            <i class="material-icons">print</i> Print
          </span>
          <vs-breadcrumb
            align="left"
            :items="
                  [
                   {title: 'You are here : '},
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/Admin/adminDashboard'
                    },
                    {
                      title: 'Reports',
                      url: '/#/dashboard/Admin/graphs',
                      active: true
                    }
                  ]"
          ></vs-breadcrumb>
        </div>
      </div>
    </div>
    <div class="container container-bdr mt-2 mb-5">
      <!-- row starts -->
      <div class="row">
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-12 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Pre & Post Assessment Report</strong>
            </span>
            <span class="float-right">
              <strong>Event Code :</strong> T327
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-4 col-bdr-bottom">
          <img :src="basepath+'/unodc_logo.png'" class="mt-2 mb-2" alt="UNODC" width="200" />
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-4 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Plot # 5-11, Diplomatic Enclave, G-5, P.O.BOX 1051, Islamabad 44000, Pakistan</strong>
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-4 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Country Office Pakistan</strong>
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-12 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Name of Event :</strong> Training on "Administrative Management, Managing Audit and Accounts"
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-8 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Start Date :</strong> 10/30/2019
            </span>
            <span class="float-right">
              <strong>Finish Date :</strong> 12/30/2019
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-4 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Output :</strong> 2.1(PACT)
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-6 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Total Pre-Assessment Forms :</strong> 27
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-6 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Total Post-Assessment Forms :</strong> 27
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-12 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Name of Trainer(s) :</strong> Barrister Ehtasham Anwar
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-4 col-bdr-bottom pb-2">
          <p class="mt-2 mb-2 text-center">
            <span>
              <strong>Average Actual Knowledge Change</strong>
            </span>
          </p>
          <canvas class="chart-container" id="myChart" width="400" height="400"></canvas>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-4 col-bdr-bottom pb-2">
          <p class="mt-2 mb-2 text-center">
            <span>
              <strong>Trained Before on this subject</strong>
            </span>
          </p>
          <div class="chart-container">
            <canvas id="myPieChart" width="400" height="400"></canvas>
          </div>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-4 col-bdr-bottom pb-2">
          <p class="mt-2 mb-2 text-center">
            <span>
              <strong>Knowledge Perception of Trainee about the subject</strong>
            </span>
          </p>
          <div class="chart-container">
            <canvas id="bar-chart-grouped" width="400" height="400"></canvas>
          </div>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-4 col-bdr-bottom pb-2">
          <p class="mt-2 mb-2 text-center">
            <span>
              <strong>Trainee Feedback About Duration of Training</strong>
            </span>
          </p>

          <canvas id="bar-chart-grouped-2" width="400" height="400"></canvas>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-4 col-bdr-bottom pb-2">
          <p class="mt-2 mb-2 text-center">
            <span>
              <strong>Relevance of the Training</strong>
            </span>
          </p>

          <canvas id="bar-chart-grouped-3" width="400" height="400"></canvas>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-4 col-bdr-bottom pb-2">
          <p class="mt-2 mb-2 text-center">
            <span>
              <strong>Future Use of Training on Job</strong>
            </span>
          </p>

          <canvas id="bar-chart-grouped-4" width="400" height="400"></canvas>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-4 col-bdr-bottom pb-2">
          <p class="mt-2 mb-2 text-center">
            <span>
              <strong>Trainee Satisfaction with Training Methods</strong>
            </span>
          </p>

          <canvas id="bar-chart-grouped-5" width="400" height="400"></canvas>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-4 col-bdr-bottom pb-2">
          <p class="mt-2 mb-2 text-center">
            <span>
              <strong>Quality of Course Material</strong>
            </span>
          </p>

          <canvas id="bar-chart-grouped-6" width="400" height="400"></canvas>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-4 col-bdr-bottom pb-2">
          <p class="mt-2 mb-2 text-center">
            <span>
              <strong>Overall Statisfaction</strong>
            </span>
          </p>

          <canvas id="bar-chart-grouped-7" width="400" height="400"></canvas>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-3 col-bdr-bottom pb-2">
          <p class="mt-2 mb-2 text-center">
            <span>
              <strong>Frequency of Skill Utilisation</strong>
            </span>
          </p>

          <canvas id="bar-chart-grouped-8" width="400" height="400"></canvas>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-3 col-bdr-bottom pb-2">
          <p class="mt-2 mb-2 text-center">
            <span>
              <strong>Participants Feedback on Training Language</strong>
            </span>
          </p>

          <canvas id="bar-chart-grouped-9" width="400" height="400"></canvas>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-3 col-bdr-bottom pb-2">
          <p class="mt-2 mb-2 text-center">
            <span>
              <strong>Practicle Excercise Used During Training</strong>
            </span>
          </p>

          <canvas id="bar-chart-grouped-10" width="400" height="400"></canvas>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-3 col-bdr-bottom pb-2">
          <p class="mt-2 mb-2 text-center">
            <span>
              <strong>Trainee Perception of Training Impact</strong>
            </span>
          </p>

          <canvas id="myPieChart-2" width="400" height="400"></canvas>
        </div>
        <!-- col-md ends -->
      </div>
      <!-- row ends -->
    </div>
    <!-- container ends -->
  </div>
</template>

<script>
import Chart from "chart.js";
import axios from "axios";
export default {
  data: () => ({
    colorx: "#2196f3",
    basepath: localStorage.getItem("BASE_PATH"),
    indexActive: 0
  }),
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    // chart 1 starts
    new Chart(document.getElementById("myChart"), {
      type: "bar",
      data: {
        labels: ["Post", "Pre"],
        datasets: [
          {
            label: "Percentage",
            data: [12, 19],
            backgroundColor: ["#e74c3c", "#3498db"]
            // borderColor: [
            //   "rgba(255, 99, 132, 1)",
            //   "rgba(54, 162, 235, 1)",
            //   "rgba(255, 206, 86, 1)",
            //   "rgba(75, 192, 192, 1)",
            //   "rgba(153, 102, 255, 1)",
            //   "rgba(255, 159, 64, 1)"
            // ]
            // borderWidth: 1
          }
        ]
      },
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                min: 0,
                max: 100,
                callback: function(value) {
                  return value + "%";
                }
              },
              scaleLabel: {
                display: true,
                labelString: "Percentage"
              }
            }
          ]
        }
      }
    });
    // chart 1 ends
    // chart 2 starts
    new Chart(document.getElementById("myPieChart"), {
      type: "pie",
      data: {
        labels: ["Yes", "No", "No Response"],
        datasets: [
          {
            backgroundColor: ["#2ecc71", "#3498db", "#95a5a6"],
            data: [12, 19, 3]
          }
        ]
      }
    });
    //chart 2 ends

    //chart 3 starts
    new Chart(document.getElementById("bar-chart-grouped"), {
      type: "bar",
      data: {
        labels: ["Knowledge Before", "Knowledge Increase"],
        datasets: [
          {
            label: "No Response",
            backgroundColor: "#f1c40f",
            data: [4, 44]
          },
          {
            label: "Very Low",
            backgroundColor: "#e74c3c",
            data: [20, 30]
          },
          {
            label: "Low",
            backgroundColor: "#2ecc71",
            data: [34, 18]
          },
          {
            label: "Medium",
            backgroundColor: "#3498db",
            data: [43, 80]
          },
          {
            label: "Hight",
            backgroundColor: "#95a5a6",
            data: [29, 23]
          },
          {
            label: "Very Hight",
            backgroundColor: "#8e5ea2",
            data: [43, 80]
          }
        ]
      },
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                min: 0,
                max: 100,
                callback: function(value) {
                  return value + "%";
                }
              },
              scaleLabel: {
                display: true,
                labelString: "Percentage"
              }
            }
          ]
        }
      }
    });
    //chart 3 ends
    // chart 4 starts
    new Chart(document.getElementById("bar-chart-grouped-2"), {
      type: "bar",
      data: {
        labels: ["Duration"],
        datasets: [
          {
            label: "Too Short",
            backgroundColor: "#f1c40f",
            data: [4, 44]
          },
          {
            label: "Too Long",
            backgroundColor: "#e74c3c",
            data: [20, 30]
          },
          {
            label: "Duration is Fine",
            backgroundColor: "#2ecc71",
            data: [34, 18]
          }
        ]
      },
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                min: 0,
                max: 100,
                callback: function(value) {
                  return value + "%";
                }
              },
              scaleLabel: {
                display: true,
                labelString: "Percentage"
              }
            }
          ]
        }
      }
    });
    // chart 4 ends
    // chart 5 starts
    new Chart(document.getElementById("bar-chart-grouped-3"), {
      type: "bar",
      data: {
        labels: [""],
        datasets: [
          {
            label: "No Response",
            backgroundColor: "#f1c40f",
            data: [30]
          },
          {
            label: "Very Low",
            backgroundColor: "#e74c3c",
            data: [30]
          },
          {
            label: "Low",
            backgroundColor: "#2ecc71",
            data: [26]
          },
          {
            label: "Medium",
            backgroundColor: "#3498db",
            data: [4]
          },
          {
            label: "Hight",
            backgroundColor: "#95a5a6",
            data: [11]
          },
          {
            label: "Very Hight",
            backgroundColor: "#8e5ea2",
            data: [43]
          }
        ]
      },
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                min: 0,
                max: 100,
                callback: function(value) {
                  return value + "%";
                }
              },
              scaleLabel: {
                display: true,
                labelString: "Percentage"
              }
            }
          ]
        }
      }
    });
    // chart 5 ends
    // chart 6 starts
    new Chart(document.getElementById("bar-chart-grouped-4"), {
      type: "bar",
      data: {
        labels: [""],
        datasets: [
          {
            label: "No Response",
            backgroundColor: "#f1c40f",
            data: [0]
          },
          {
            label: "Very Low",
            backgroundColor: "#e74c3c",
            data: [11]
          },
          {
            label: "Low",
            backgroundColor: "#2ecc71",
            data: [4]
          },
          {
            label: "Medium",
            backgroundColor: "#3498db",
            data: [22]
          },
          {
            label: "Hight",
            backgroundColor: "#95a5a6",
            data: [42]
          },
          {
            label: "Very Hight",
            backgroundColor: "#8e5ea2",
            data: [22]
          }
        ]
      },
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                min: 0,
                max: 100,
                callback: function(value) {
                  return value + "%";
                }
              },
              scaleLabel: {
                display: true,
                labelString: "Percentage"
              }
            }
          ]
        }
      }
    });
    // chart 6 ends
    // chart 7 starts
    new Chart(document.getElementById("bar-chart-grouped-5"), {
      type: "bar",
      data: {
        labels: [""],
        datasets: [
          {
            label: "No Response",
            backgroundColor: "#f1c40f",
            data: [0]
          },
          {
            label: "Not Satisfied",
            backgroundColor: "#e74c3c",
            data: [0]
          },
          {
            label: "Somewhat Satisfied",
            backgroundColor: "#2ecc71",
            data: [11]
          },
          {
            label: "Satisfied",
            backgroundColor: "#3498db",
            data: [4]
          },
          {
            label: "Very Satisfied",
            backgroundColor: "#95a5a6",
            data: [44]
          },
          {
            label: "Highly Satisfied",
            backgroundColor: "#8e5ea2",
            data: [41]
          }
        ]
      },
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                min: 0,
                max: 100,
                callback: function(value) {
                  return value + "%";
                }
              },
              scaleLabel: {
                display: true,
                labelString: "Percentage"
              }
            }
          ]
        }
      }
    });
    // chart 7 ends
    // chart 8 starts
    new Chart(document.getElementById("bar-chart-grouped-6"), {
      type: "bar",
      data: {
        labels: [""],
        datasets: [
          {
            label: "No Response",
            backgroundColor: "#f1c40f",
            data: [11]
          },
          {
            label: "Not Satisfied",
            backgroundColor: "#e74c3c",
            data: [0]
          },
          {
            label: "Somewhat Satisfied",
            backgroundColor: "#2ecc71",
            data: [0]
          },
          {
            label: "Satisfied",
            backgroundColor: "#3498db",
            data: [11]
          },
          {
            label: "Very Satisfied",
            backgroundColor: "#95a5a6",
            data: [33]
          },
          {
            label: "Highly Satisfied",
            backgroundColor: "#8e5ea2",
            data: [45]
          }
        ]
      },
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                min: 0,
                max: 100,
                callback: function(value) {
                  return value + "%";
                }
              },
              scaleLabel: {
                display: true,
                labelString: "Percentage"
              }
            }
          ]
        }
      }
    });
    // chart 8 ends
    // chart 9 starts
    new Chart(document.getElementById("bar-chart-grouped-7"), {
      type: "bar",
      data: {
        labels: [""],
        datasets: [
          {
            label: "No Response",
            backgroundColor: "#f1c40f",
            data: [0]
          },
          {
            label: "Not Satisfied",
            backgroundColor: "#e74c3c",
            data: [0]
          },
          {
            label: "Somewhat Satisfied",
            backgroundColor: "#2ecc71",
            data: [0]
          },
          {
            label: "Satisfied",
            backgroundColor: "#3498db",
            data: [11]
          },
          {
            label: "Very Satisfied",
            backgroundColor: "#95a5a6",
            data: [48]
          },
          {
            label: "Highly Satisfied",
            backgroundColor: "#8e5ea2",
            data: [41]
          }
        ]
      },
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                min: 0,
                max: 100,
                callback: function(value) {
                  return value + "%";
                }
              },
              scaleLabel: {
                display: true,
                labelString: "Percentage"
              }
            }
          ]
        }
      }
    });
    // chart 9 ends
    // chart 10 starts
    new Chart(document.getElementById("bar-chart-grouped-8"), {
      type: "bar",
      data: {
        labels: ["Pre", "Post"],
        datasets: [
          {
            label: "Everyday",
            backgroundColor: "#f1c40f",
            data: [4, 44]
          },
          {
            label: "Weekly",
            backgroundColor: "#e74c3c",
            data: [20, 30]
          },
          {
            label: "Rarely",
            backgroundColor: "#2ecc71",
            data: [34, 18]
          },
          {
            label: "Never",
            backgroundColor: "#3498db",
            data: [43, 80]
          }
        ]
      },
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                min: 0,
                max: 100,
                callback: function(value) {
                  return value + "%";
                }
              },
              scaleLabel: {
                display: true,
                labelString: "Percentage"
              }
            }
          ]
        }
      }
    });
    // chart 10 ends
    // chart 11 starts
    new Chart(document.getElementById("bar-chart-grouped-9"), {
      type: "bar",
      data: {
        labels: ["Language"],
        datasets: [
          {
            label: "Difficult to Understand",
            backgroundColor: "#f1c40f",
            data: [0]
          },
          {
            label: "Understandable",
            backgroundColor: "#e74c3c",
            data: [19]
          },
          {
            label: "Easy",
            backgroundColor: "#2ecc71",
            data: [81]
          }
        ]
      },
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                min: 0,
                max: 100,
                callback: function(value) {
                  return value + "%";
                }
              },
              scaleLabel: {
                display: true,
                labelString: "Percentage"
              }
            }
          ]
        }
      }
    });
    // chart 11 ends
    // chart 12 starts
    new Chart(document.getElementById("bar-chart-grouped-10"), {
      type: "bar",
      data: {
        labels: ["Practicle"],
        datasets: [
          {
            label: "Enough",
            backgroundColor: "#f1c40f",
            data: [30]
          },
          {
            label: "Too Much",
            backgroundColor: "#e74c3c",
            data: [17]
          },
          {
            label: "Too Little",
            backgroundColor: "#2ecc71",
            data: [53]
          }
        ]
      },
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                min: 0,
                max: 100,
                callback: function(value) {
                  return value + "%";
                }
              },
              scaleLabel: {
                display: true,
                labelString: "Percentage"
              }
            }
          ]
        }
      }
    });
    // chart 12 ends
    // chart 13 starts
    new Chart(document.getElementById("myPieChart-2"), {
      type: "pie",
      data: {
        labels: [
          "My Duty Station",
          "My Agency or Department",
          "My Personal Work"
        ],
        datasets: [
          {
            backgroundColor: ["#2ecc71", "#3498db", "#95a5a6"],
            data: [36, 36, 28]
          }
        ]
      }
    });
    //chart 13 ends
  },
  methods: {
    printReport: function() {
      window.print();
    }
  }
};
</script>
<style scoped>
.myNavbar {
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1), 0 5px 5px rgba(0, 0, 0, 0.1) !important;
}
.container-bdr {
  border-top: 1px solid #ebe9e9;
  border-right: 1px solid #ebe9e9;
}
.col-bdr-bottom {
  border-bottom: 0.5px solid #ebe9e9;
  border-left: 0.5px solid #ebe9e9;
}
.nav-route-link {
  background: none !important;
  border-right: 0px !important;
}
.chart-container {
  position: relative;
  margin: auto;
  height: 340px;
  width: 340px;
}
.chart-container-sm {
  position: relative;
  margin: auto;
  height: 250px;
  width: 250px;
}
@media print {
  .print-btn {
    display: none;
  }
  .col-bdr-bottom {
    border-bottom: none !important;
    border-left: none !important;
  }
  .container-bdr {
    border-top: none !important;
    border-right: none !important;
  }
}
</style>
<style>
.vs-navbar--header {
  height: 60px;
  padding: 20px;
}
.vs-con-items {
  padding: 20px;
}
@media screen and (max-width: 800px) {
  .vs-con-items.activeMenuResponsive {
    background-color: #46637a !important;
  }
}
</style>